import { WithSelector } from '~/components/wrappers/WithSelector';
import { selectArticles } from '~/selectors/selectArticles';

export function WithHomePageArticles(ArticlesComponent, options = {}) {
  return WithSelector(ArticlesComponent, (props) => selectArticles(props, options), {
    propTypesOverride: {
      rawArticles: {
        type: Array,
        default: () => []
      }
    }
  });
}
